import { render, staticRenderFns } from "./Leg.vue?vue&type=template&id=942476a2&scoped=true"
import script from "./Leg.vue?vue&type=script&lang=js"
export * from "./Leg.vue?vue&type=script&lang=js"
import style0 from "./Leg.vue?vue&type=style&index=0&id=942476a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942476a2",
  null
  
)

export default component.exports